var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFreeDayIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Free_Day_icon_svg__clip0_2002_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723.81 233.333H276.191c-13.15 0-23.81 10.66-23.81 23.81v428.571c0 13.15 10.66 23.81 23.81 23.81H723.81c13.149 0 23.809-10.66 23.809-23.81V257.143c0-13.15-10.66-23.81-23.809-23.81z",
    fill: "#CAE0E3",
    stroke: "#80BBD6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.619 271.429h304.762",
    stroke: "#80BBD6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.81 309.524H276.191c-13.15 0-23.81 10.66-23.81 23.809V800c0 13.15 10.66 23.81 23.81 23.81H723.81c13.149 0 23.809-10.66 23.809-23.81V333.333c0-13.149-10.66-23.809-23.809-23.809z",
    fill: "#fff",
    stroke: "#93D5DE",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 766.667c73.638 0 133.333-59.696 133.333-133.334S573.638 500 500 500s-133.333 59.695-133.333 133.333S426.362 766.667 500 766.667z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.905 679.202c7.952 12.691 22.047 21.143 38.095 21.143s30.143-8.452 38.095-21.143",
    stroke: "#FA505E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.571 376.191c-15.75 0-28.571-12.822-28.571-28.572V195.238c0-15.75 12.821-28.571 28.571-28.571 15.75 0 28.572 12.821 28.572 28.571v152.381c0 15.75-12.822 28.572-28.572 28.572z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.571 176.191c10.477 0 19.048 8.571 19.048 19.047v152.381c0 10.476-8.571 19.048-19.048 19.048-10.476 0-19.047-8.572-19.047-19.048V195.238c0-10.476 8.571-19.047 19.047-19.047zm0-19.048c-21.011 0-38.095 17.095-38.095 38.095v152.381c0 21 17.084 38.095 38.095 38.095 21.012 0 38.096-17.095 38.096-38.095V195.238c0-21-17.084-38.095-38.096-38.095z",
    fill: "#76ADB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.857 376.191c-15.75 0-28.571-12.822-28.571-28.572V195.238c0-15.75 12.821-28.571 28.571-28.571 15.75 0 28.572 12.821 28.572 28.571v152.381c0 15.75-12.822 28.572-28.572 28.572z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.857 176.191c10.476 0 19.048 8.571 19.048 19.047v152.381c0 10.476-8.572 19.048-19.048 19.048-10.476 0-19.047-8.572-19.047-19.048V195.238c0-10.476 8.571-19.047 19.047-19.047zm0-19.048c-21.012 0-38.095 17.095-38.095 38.095v152.381c0 21 17.083 38.095 38.095 38.095s38.095-17.095 38.095-38.095V195.238c0-21-17.083-38.095-38.095-38.095z",
    fill: "#76ADB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.143 376.191c-15.75 0-28.572-12.822-28.572-28.572V195.238c0-15.75 12.822-28.571 28.572-28.571s28.571 12.821 28.571 28.571v152.381c0 15.75-12.821 28.572-28.571 28.572z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.143 176.191c10.476 0 19.047 8.571 19.047 19.047v152.381c0 10.476-8.571 19.048-19.047 19.048s-19.048-8.572-19.048-19.048V195.238c0-10.476 8.572-19.047 19.048-19.047zm0-19.048c-21.012 0-38.095 17.095-38.095 38.095v152.381c0 21 17.083 38.095 38.095 38.095s38.095-17.095 38.095-38.095V195.238c0-21-17.083-38.095-38.095-38.095z",
    fill: "#76ADB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.429 376.191c-15.75 0-28.572-12.822-28.572-28.572V195.238c0-15.75 12.822-28.571 28.572-28.571S700 179.488 700 195.238v152.381c0 15.75-12.821 28.572-28.571 28.572z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.429 176.191c10.476 0 19.047 8.571 19.047 19.047v152.381c0 10.476-8.571 19.048-19.047 19.048-10.477 0-19.048-8.572-19.048-19.048V195.238c0-10.476 8.571-19.047 19.048-19.047zm0-19.048c-21.012 0-38.096 17.095-38.096 38.095v152.381c0 21 17.084 38.095 38.096 38.095 21.012 0 38.095-17.095 38.095-38.095V195.238c0-21-17.083-38.095-38.095-38.095z",
    fill: "#76ADB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.762 423.81H395.238c-10.52 0-19.048 8.527-19.048 19.047 0 10.52 8.528 19.048 19.048 19.048h209.524c10.52 0 19.047-8.528 19.047-19.048 0-10.52-8.527-19.047-19.047-19.047z",
    fill: "#40A9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.143 635.178a9.524 9.524 0 100-19.047 9.524 9.524 0 100 19.047zM542.857 635.178a9.524 9.524 0 100-19.047 9.524 9.524 0 100 19.047z",
    fill: "#006C78",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Free_Day_icon_svg__clip0_2002_338"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeDayIcon);
export default ForwardRef;